﻿/// <reference path="../lib/jquery.d.ts" />
/// <reference path="../lib/googleMaps.d.ts" />
import {Controller} from "./helpers/controller";
import {PopupControl, PopupControlConfig} from "./popupControl";
import {GoogleMapControl, Marker} from "./googleMapControl";

interface image {
    title: string,
    description: string,
    url: string
}

export interface schoolListing {
    name: string,
    centerId: string,
    contactNumber: string,
    address: string,
    image: image,
    lat: number,
    lng: number,
    distance: number,
    url: string,
}

class findSchoolSelectors {
    public static findSchoolModule: string = '#schoolPopup';
    public static schoolList: string = '#schoolList';
    public static schoolListCards: string = '#schoolList .linkCard';
    public static schoolListCard: string = '[data-schoolCard]';
    public static noResults: string = '[data-schoolResults]';
    public static mapView: string = '#schoolPopup #mapView';
    public static listView: string = '#schoolPopup #listView';
    public static tabs: string = '[data-tabs="schoolFinder"]';
    public static postcodeValidation: string = '[data-findSchool-validation]';
    public static switchToOnline: string = '#schoolPopup .cantFind';
    public static exploreOnline: string = '#schoolPopup .exploreOnline';
    public static searchForms: string = '[data-findSchool-form]';
}

export class findSchoolControl extends Controller {

    private findSchoolModule = () => $(findSchoolSelectors.findSchoolModule);
    private readonly findSchoolHtml = this.findSchoolModule().html();
    private schoolCardHtml: string;
    private schoolList = () => $(findSchoolSelectors.schoolList);
    private form = () => $(this._element);

    private schoolListHtml: string = this.schoolList().html();

    private readonly schoolMapPopupHtml: string = `<div class="schoolPopup">
    <h3>{{name}}</h3>
    <p>{{address}}</p>
    <p><a href="tel:{{contactNumber}}">{{contactNumber}}</a></p>
    <button class="button copyButton">Select this school</button>
</div>`
    private popupControl?: PopupControl;

    private postcode: string = '';
    private distance: number = 50;
    private resultsToShow: number = 3;
    private redirectOnSelect: boolean;
    public selectedSchool?: schoolListing;
    public selectCallback?: (school: schoolListing) => void;
    public linkCallback?: () => void;

    private map?: GoogleMapControl

    constructor(element: HTMLElement, redirectOnSelect: boolean = true, selectCallback?: (school: schoolListing) => void, linkCallback?: () => void) {
        super(element);

        this.map = new GoogleMapControl($(findSchoolSelectors.mapView).get()[0] as HTMLElement);

        this.redirectOnSelect = redirectOnSelect;
        this.selectCallback = selectCallback;
        this.linkCallback = linkCallback;

        this.schoolCardHtml = this.findSchoolModule().find(findSchoolSelectors.schoolListCard)[0].outerHTML;

        this.findSchoolModule().find(findSchoolSelectors.schoolListCard).remove();
        this.schoolListHtml = this.schoolList().html();

        let config: PopupControlConfig = {
            popupElement: this.findSchoolModule().get()[0],
            defaultEvents: false,
            scrollTo: 0
        }
        this.popupControl = new PopupControl(element, config);

        let formButtons = this.form()
        formButtons.submit((event) => {

            event.preventDefault();
            const formData = new FormData(event.currentTarget as HTMLFormElement);

            let postcode = formData.get('postcode') ?? '';
            
            if (postcode === '')
            {
                this.invalidPostcode();
            }
            else
            {
                this.open(postcode.toString());
            }
        })

        let searchAgainFormButtons = $(findSchoolSelectors.searchForms);
        searchAgainFormButtons.submit((event) => {
            
            event.preventDefault();
            const formData = new FormData(event.currentTarget as HTMLFormElement);

            let postcode = formData.get('postcode') ?? '';
            if (postcode === '')
            {
                this.invalidPostcode();
            }
            else
            {
                this.open(postcode.toString());
            }
        })


        let urlPostcode = this.getUrlParameter('postcode')
        if (urlPostcode) {
            this.open(urlPostcode);
        }

        if (this.linkCallback != null) {
            this.setupLink();
        }
    }

    setupLink = () => {
        let switchToOnlineSection = $(findSchoolSelectors.switchToOnline)
        switchToOnlineSection.find('a').click((event) => {
            if (this.linkCallback != null) {
                this.linkCallback();
                event.preventDefault();
            }
        });

        switchToOnlineSection.show();
        $(findSchoolSelectors.exploreOnline).hide();
    }


    getUrlParameter = (sParam: string) => {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;

        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? false : decodeURIComponent(sParameterName[1]);
            }
        }
        return false;
    };

    replaceQueryParam = (param: string, newval: string, search: string) => {
        var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
        var query = search.replace(regex, "$1").replace(/&$/, '');

        return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
    }
    replaceTokens = (name: string, value: string, source: string) => {
        return source.replaceAll("{{" + name + "}}", value);
    }

    loadGoogleMaps = () => {
        // Create the script tag, set the appropriate attributes
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyAlMU0LxsgA4KPPo6So6PndggciJ_i_oJg';
        script.async = true;

        // Append the 'script' element to 'head'
        document.head.appendChild(script);
    }

    public open = (postcode: string) => {

        this.postcode = postcode;

        var str = window.location.search
        str = this.replaceQueryParam('postcode', postcode, str)

        if (window.history.replaceState) {
            //prevents browser from storing history with each change:
            window.history.replaceState({}, '', window.location.pathname + str);
        }

        this.validPostcode();

        this.displaySchools();
    }

    public close = () => {
        this.popupControl?.close();
    }

    invalidPostcode = () => {
        //this.popupControl?.close();
        $(findSchoolSelectors.postcodeValidation).show();
    }

    validPostcode = () => {
        $(findSchoolSelectors.postcodeValidation).hide();
    }

    displaySchools = () => {
        var _this = this;

        $(findSchoolSelectors.schoolList).hide();

        let noResults = $(findSchoolSelectors.noResults);
        noResults.html(_this.replaceTokens('distance', _this.distance.toString(), noResults.html()))
        noResults.hide();

        var googleMapsLoad = setInterval(() => {
            if (typeof google === 'object' && typeof google.maps === 'object') {
                clearInterval(googleMapsLoad);

                //first, get coordinates for the postcode provided
                var geocoder = new google.maps.Geocoder();

                geocoder.geocode({address: this.postcode + ", UK"},
                    function (results, status) {
                        if (status == google.maps.GeocoderStatus.OK && results != null) {
                            let location = results[0].geometry.location
                            _this.popupControl?.open();

                            _this.getSchools(location, _this.distance).then(function (schools: Array<schoolListing>) {

                                if (schools.length > 0) {
                                    schools.forEach((school) => {
                                        school.distance = _this.getDistanceFromLatLonInMiles(location, school.lat, school.lng)
                                    });
                                    _this.renderSchools(_this, schools, location, false);

                                } else {
                                    _this.getSchools(location, 9999).then(function (noResultsSchools: Array<schoolListing>) {
                                        noResultsSchools.forEach((noResultsSchool) => {
                                            noResultsSchool.distance = _this.getDistanceFromLatLonInMiles(location, noResultsSchool.lat, noResultsSchool.lng)
                                        });
                                        _this.renderSchools(_this, noResultsSchools, location, true);
                                    })
                                }
                            })
                        } else {
                            _this.invalidPostcode();
                        }
                    })

            }
        }, 500)

    }

    getDistanceFromLatLonInMiles = (location: google.maps.LatLng, schoolLat: number, schoolLon: number) => {
        var R = 6371; // Radius of the earth in km
        var dLat = this.deg2rad(schoolLat - location.lat());  // deg2rad below
        var dLon = this.deg2rad(schoolLon - location.lng());
        var a =
            Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(this.deg2rad(location.lat())) * Math.cos(this.deg2rad(schoolLat)) *
            Math.sin(dLon / 2) * Math.sin(dLon / 2)
        ;
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        var d = R * c; // Distance in km
        return d / 1.609;
    }

    deg2rad = (deg: number) => {
        return deg * (Math.PI / 180)
    }

    renderSchools = (_this: this, schools: Array<schoolListing>, location: google.maps.LatLng, showNoResults: boolean) => {

        let noResults = $(findSchoolSelectors.noResults);

        let schoolHtml = _this.replaceTokens('postcode', _this.postcode, _this.schoolListHtml);
       

        $(findSchoolSelectors.schoolListCards).remove();

        if (schools.length > 0) {
            schools = schools.slice(0,this.resultsToShow);
            _this.schoolList().html(_this.replaceTokens('count', schools.length.toString(), schoolHtml));
            _this.renderSchoolListing(schools);
            _this.renderMap(schools, location);
            $(findSchoolSelectors.schoolList).show();
            $(findSchoolSelectors.tabs).show();
        }

        if (showNoResults) {
            noResults.show();
        } else {
            noResults.hide();
        }
    }

    getSchools = (location: google.maps.LatLng, distance: number) => {
        return $.get(`/api/school/nearest?lat=${location.lat()}&lng=${location.lng()}&distance=${distance}`)
    }

    createElementFromHTML = (htmlString: string) => {
        var div = document.createElement('div');
        div.innerHTML = htmlString.trim();

        // Change this to div.childNodes to support multiple top-level nodes.
        return div.firstChild as Element;
    }

    renderSchoolListing = (schools: Array<schoolListing>) => {
        let _this = this;
        let sortedSchools = schools.sort((a, b) => {
            return a.distance - b.distance;
        });

        sortedSchools.forEach((school, index: number) => {
        
                let html = this.replaceTokens('name', school.name, this.schoolCardHtml);
                html = this.replaceTokens('address', school.address, html);
                html = this.replaceTokens('distance', school.distance.toFixed(2), html);

                html = this.replaceTokens('imageUrl', school.image.url, html);
                html = this.replaceTokens('imageDescription', school.image.description, html);

                let schoolElement = this.createElementFromHTML(html);

                $(schoolElement).click(school, (event) => {
                    this.selectSchool(school);
                    event.preventDefault();
                });

                this.schoolList().append(schoolElement);
            

        })

    }

    renderMap = (schools: Array<schoolListing>, location: google.maps.LatLng) => {
        let _this = this;
        let markers: Array<Marker> = [];

        schools.forEach((school, index) => {
         
                let html = this.replaceTokens('name', school.name, this.schoolMapPopupHtml);
                html = this.replaceTokens('address', school.address, html);
                html = this.replaceTokens('contactNumber', school.contactNumber, html);

                let content = $.parseHTML(html);
                $(content).find('button').click(school, (event) => {
                    this.selectSchool(school);
                    event.preventDefault();
                })

                let marker: Marker = {
                    lat: school.lat,
                    lng: school.lng,
                    name: school.name,
                    content: content[0] as Element
                }
                markers.push(marker);
      
        })

        this.map?.renderMap(markers, location.lat(), location.lng());

    }
    selectSchool = (school: schoolListing) => {
        this.selectedSchool = school;
        if (this.redirectOnSelect) {
            window.location.href = school.url;
        }
        if (this.selectCallback != null) {
            this.selectCallback(school);
        }
    }

}

